<template>
		<section style="overflow: hidden;">
		<el-row :gutter="10" style="margin-left: 5px;overflow: hidden;">
			<el-col :span="13" style="padding-bottom: 0px;">
				<el-card class="box-card" style="height: 160px;">
					<div style="font-size:17px;font-weight:bold;">基本信息</div>
					<ul class="custMaincls">				
						<li>
							<div class="title">机构数</div>
							<div class="num">{{mainCount.schoolCount}}</div>
						</li>
						<li>
							<div class="title">用户数</div>
							<div class="num">{{mainCount.userCount}}</div>
						</li>
						<li>
							<div class="title">付费用户数</div>
							<div class="num">{{mainCount.userVipCount}}</div>
						</li>
						<li>
							<div class="title">活跃用户</div>
							<div class="num">{{mainCount.userLiveCount}}</div>
						</li>
						<li>
							<div class="title">题库数</div>
							<div class="num">{{mainCount.exerciseCount}}</div>
						</li>
					</ul>
				</el-card>
			</el-col>
			<el-col :span="10" style="padding-bottom: 0px;display: flex;">
				<el-card class="box-card" style="width: 48%;" :body-style="{ padding: '5px' }">
					<div style="text-align: center;">今日学习占比</div>
					<div ref="divUseRateChart" class="echart-pie"></div>
				</el-card>
				<el-card class="box-card" style="width: 48%;margin-left: 10px;" :body-style="{ padding: '5px' }">
					<div style="text-align: center;">7天活跃占比</div>
					<div ref="divTimeCountRateChart" class="echart-pie"></div>
				</el-card>
			</el-col>
		</el-row>
		<el-row :gutter="10" style="margin-left: 5px; margin-top: 10px; overflow: hidden;">
			<el-col :span="24" style="padding-bottom: 0px;">
				<el-card class="box-card" style="width: 100%;margin-top: 10px;" :body-style="{ padding: '5px' }">
					<div style="display: flex;">
						<div style="text-align: left;width: 15%;font-size:14px;font-weight:bold;padding-left: 10px">近30天学习人数趋势图</div>
						<div style="text-align: right;width: 80%;">
						</div>
					</div>
					<div ref="divLampRateChart" style="width: 99%;height: 300px;"></div>
				</el-card>
			</el-col>
		</el-row>
	</section>
</template>

<script>
export default {
	data() {
		return {
			yearDict:[{valuekey:2024,textkey:"2024"},{valuekey:2023,textkey:"2023"}],
			yearArr:[2024,2024,2024,2024,2024,2024],
			mainCount:{
				"schoolCount": 0,
				"userCount": 0,
				userVipCount:0,
				userLiveCount:0,
				"exerciseCount": 0,
				studyUserCount:0,
				useRate:0,
				timeCountRate:0,
				studyusercount:[]
			},
		}
	},
	methods: {
	 	async loadMainCount(type,year){
		 	this.mainCount= (await this.$axios.get("/home/getStat_homeMainCount?type="+type+"&year="+year+"&rnd=" + new Date().getTime())).data.data
			this.mainCount.useRate=(this.$util.calc_divisionFunc(this.mainCount.studyUserCount,this.mainCount.userCount)*100).toFixed(0)
			this.mainCount.timeCountRate=(this.$util.calc_divisionFunc(this.mainCount.userLiveCount,this.mainCount.userCount)*100).toFixed(0)
			this.getStudyUserCount()
		},
		getUseRateChart() {
			// 基于准备好的dom，初始化echarts实例
			const userdom = this.$refs.divUseRateChart
			const mycart = this.$echarts.init(userdom)
			let option = {
				title: {
					text: this.mainCount.useRate+'%',
					left: "38%",
					top: "40%",
					textStyle: {
						color: "#000",
						fontSize: 14,
						align: "center",
					},
				},
				legend: {
					orient: 'vertical',
					left: 'center'
				},
				series: [
					{
						name: '',
						type: 'pie',
						radius: ['40%', '70%'],
						avoidLabelOverlap: false,
						label: {
							show: false,
							position: 'center'
						},
						labelLine: {
							show: false
						},
						data: [
							{ value: this.mainCount.useRate, name: '' },
							{ value: 100-this.mainCount.useRate, name: '', itemStyle: { color: '#D7D7D7' }  },
						]
					}
				]
			}
			mycart.setOption(option)
		},
		getTimeCountRateChart() {
			// 基于准备好的dom，初始化echarts实例
			const userdom = this.$refs.divTimeCountRateChart
			const mycart = this.$echarts.init(userdom)
			let option = {
				title: {
					text: this.mainCount.timeCountRate+'%',
					left: "38%",
					top: "40%",
					textStyle: {
						color: "#000",
						fontSize: 14,
						align: "center",
					},
				},
				legend: {
					orient: 'vertical',
					left: 'center'
				},
				series: [
					{
						name: '',
						type: 'pie',
						radius: ['40%', '70%'],
						avoidLabelOverlap: false,
						label: {
							show: false,
							position: 'center'
						},
						labelLine: {
							show: false
						},
						data: [
							{ value: this.mainCount.timeCountRate, name: '' },
							{ value: 100-this.mainCount.timeCountRate, name: '', itemStyle: { color: '#D7D7D7' }  },
						]
					}
				]
			}
			mycart.setOption(option)
		},
	 	async getStudyUserCount() {
			const userdom = this.$refs.divLampRateChart
			const mycart = this.$echarts.init(userdom)
			let data=[],data2=[];
			this.mainCount.studyusercount.map(v=>{
				data.push(v.statKey)
				data2.push(v.statValue)
			})
			let option = {
				tooltip: {
					trigger: 'axis',
					formatter:'{b}<br/>用户：{c}人',
					axisPointer: {
					type: 'shadow'
					}
				},
				xAxis: {
					type: 'category',
					data: data
				},
				yAxis: {
					type: 'value'
				},
				series: [
					{
						name: '人数',
						data: data2,
						type: 'line'
					}
				]
			};
			mycart.setOption(option)
		},
	},
	async created() {
		
	},
   async mounted() {
	await this.loadMainCount(1,2024)
	 this.getUseRateChart()
		this.getTimeCountRateChart()

	}
}

</script>


<style scoped lang="scss">
.el-card__body {
	padding: 5px !important;
	height: 160px;
}

.custMaincls {
	list-style-type: none;
	margin: 0;
	margin-top: 25px;
	padding: 0;
	display: flex;

	/* 使用Flex布局 */
	li {
		margin-right: 10px;
		/* 可选，为元素之间增加间隔 */
		width: 80px;
		border-right: 1px solid #ccc;

		.title {
			font-size: 14px;
			text-align: center;
		}

		.num {
			margin-top: 10px;
			font-size: 14px;
			font-weight: bold;
			text-align: center;
		}
	}
}

.echart-pie {
	width: 130px;
	height: 130px;
	border: 0px solid pink;
	margin: 0px auto;
	padding: 0;
}
.multiple-table /deep/.el-table__body-wrapper {
    height: 86%!important;
  }
</style>
